import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Automation">
                <h1>Business Automation Consulting Services</h1>
              </div>
              <p className="main_para">
                Achieve your business objectives faster with our business
                automation consulting
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                Put the right talent, data, and intelligence into action for
                business transformation.
              </p>
              <ul>
                <li>Data-Led Automation</li>
                <li>Workflow Growth and Scalability</li>
                <li>Practice to Performance Covered</li>
                <li>Future-Ready Business Processes</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
